import { z } from 'zod';
import { DeepRequired } from '../../../utils';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { uuid } from '../../utils';

export const promocode = extendApi(
  z.object({
    id: uuid,
    code: extendApi(z.string().min(1), {
      description: 'Code/value of the promocode',
      example: 'X1Y2Z3',
    }),
    // codeBatchId: id, // TODO reintroduce
  }),
  {
    description: 'Promocode given as a reward to a member',
    tags: ['promocode-model', 'promocode', 'model'],
  },
);

export const publicPromocodeRef = extendApi(promocode, {
  $ref: '#/components/schemas/Promocode',
} as RedocSchemaObject);

export type PublicPromocode = DeepRequired<z.infer<typeof promocode>>;
